const React = require('react');
const classnames = require('classnames');

const getListIsins = (immBrokerExchangeIndexes) => {
    return immBrokerExchangeIndexes.get('indexes').toJS().map((index) => {
        return index.instrumentId
    });
}

const getMinLengthIndexes = (immBrokerMarket) => {
    let hasMinLength = true;

    if (immBrokerMarket.get('indexesData').length !== 0) {
        immBrokerMarket.get('indexesData').map((index) => {
            if(hasMinLength && index)
                hasMinLength = index.length > 10;
        });
    }
}

const buildArrowIcon = (direction, type) => {

    let contentGridClassName;

    if (type === 'indexes') {
        contentGridClassName = classnames(
            'icon-alza broker-markets-indexes__header-chart__content-sub-section__arow-icon',
            {
                'broker-markets-indexes__header-chart__content-sub-section__arow-icon__up': !direction,
                'broker-markets-indexes__header-chart__content-sub-section__arow-icon__down': direction
            }
        );
    } else {
        contentGridClassName = classnames(
            'icon-alza broker-markets-view__arow-icon',
            {
                'broker-markets-view__arow-icon__up': direction === 'up',
                'broker-markets-view__arow-icon__down': direction=== 'down'
            }
        );
    }

    return (
        <i className={contentGridClassName}></i>
    )
}

const getListNews = (news, quantity) => {
    return news.filter(market => market.title1 !== null).slice(0, quantity)
}

const buildGridFinancesView = (financesNews) => {
    let newGrid = [];

    const gridWithRows = financesNews.map((gridContent, index) => {
        if (index === 0 || index === 4 || index === 7 || index === 9 || index === 12) {
            const contentNewGrid = index === 0 ? gridContent : newGrid;
            newGrid = [];

            if(index !== 0)
                newGrid.push(gridContent);

            return (
                <div className="row" key={index.toString()}>
                    {contentNewGrid}
                </div>
            )
        }
        else {
            newGrid.push(gridContent);
        }
    })

    if (newGrid.length > 0) {
        gridWithRows.push(
            <div className="row">
                {newGrid}
            </div>
        )
    }


    return gridWithRows;
}

const getClassGridContent = (index) => {
    const contentGridClassName = classnames(
        'broker-markets-finances-news__box-news__content',
        {
            '-big': index === 0,
            '-medium': index > 6 && index <= 8,
            '-small': index > 0 && index <= 6 || index > 8
        }
    );

    const contentGridColClassName = classnames(
        {
            'col-xs-12': index === 0,
            'col-xs-6': index > 6 && index <= 8,
            'col-xs-4': index > 0 && index <= 6 || index > 8
        }
    );

    return {
        contentGridClassName,
        contentGridColClassName
    };
}

module.exports = {
    getListIsins,
    getMinLengthIndexes,
    buildArrowIcon,
    getListNews,
    buildGridFinancesView,
    getClassGridContent
}